import type { ComponentType } from 'react';

import { SidebarMenuItem, SidebarMenuItemProps } from '../../types';

import { SidebarLinkItem } from './SidebarItems/SidebarLinkItem';
import { SidebarCustomLinkItem } from './SidebarItems/SidebarCustomLinkItem';
import { SidebarSectionItem } from './SidebarItems/SidebarSectionItem';
import { SidebarUserSectionItem } from './SidebarItems/SidebarUserSectionItem';
import { SidebarDropdownItem } from './SidebarItems/SidebarDropdownItem';

const sidebarItemMapper: {
  [K in SidebarMenuItem['type']]: ComponentType<SidebarMenuItemProps<K>>;
} = {
  link_item: SidebarLinkItem,
  custom_link_item: SidebarCustomLinkItem,
  section_item: SidebarSectionItem,
  custom_section_item: SidebarSectionItem,
  dropdown_item: SidebarDropdownItem,
  custom_dropdown_item: SidebarDropdownItem,
  user_section_item: SidebarUserSectionItem,
};

export const SidebarMappedItem = <K extends SidebarMenuItem['type']>({
  item,
  ...rest
}: SidebarMenuItemProps<K>) => {
  const Component: ComponentType<SidebarMenuItemProps<K>> | undefined =
    sidebarItemMapper[item.type];

  if (!Component) {
    return null;
  }

  return <Component item={item} {...rest} />;
};
